<template>
  <b-modal class="modal-md" size="md" id="modalSendBlacklistRemovalRequest" ref="modalSendBlacklistRemovalRequest" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @show="assignValues()" @hide="closeModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'envelope']" class="mr-2"/> {{ t('blacklistEmailsRemovalTitle', 'blacklistEmailsRemovalTitle') }} </h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="col-12">
        {{ t('selectedBlacklistEmailsForRemovalTitleQuestion', 'selectedBlacklistEmailsForRemovalTitleQuestion') }} <br>
      </div>
      <div v-if="data" class="col-12 mt-2">
        <template>
          <div v-for="email in data.userEmails">
            <div class="col-12 px-0">
              <span>{{ email }}</span>
            </div>
          </div>
        </template>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ok,cancel}">
      <button class="btn btn-primary" @click="sendBlacklistEmailUnlockRequest(), ok()">Send email</button>
      <b-button variant="secondary" @click="cancel()">Cancel</b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'ModalSendBlacklistRemovalRequest',
  data () {
    return {
      data: null
    }
  },
  methods: {
    closeModal() {
      this.$parent.modalData = {}
    },
    assignValues() {
      if(this.$attrs.modalData) {
        this.data = this.$attrs.modalData
      } else {
        this.data = null
      }
    },
    // Send blacklist removal request email
    sendBlacklistEmailUnlockRequest() {
      if(this.modalData.userEmails) {
        this.$store.dispatch('sendMassBlacklistRemovalRequest', {
          userEmails: this.modalData.userEmails
        }).then(response => {
          this.closeModal()
        })
      }
    }
  },
  computed: {
    modalData() {
      return this.$attrs.modalData
    },    
  },
  filters: {
    timestampToDate(timestamp) {
      return moment.unix(timestamp).format('LLLL')
    }
  }
}
</script>

<style scoped>
  .button-h {
    max-height: 30px;
  }
  .table  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
  .table >>> .hover-pointer:hover {
    cursor: pointer !important;
  }
</style>
